import { DatePipe } from "@angular/common";
import { Component } from '@angular/core';
import { SplitByCapitalLetterPipePipe } from "@shared/pipes/split-by-capital-letter-pipe.pipe";
import { ICellRendererParams } from "ag-grid-community";
import { SignGroup } from "@models/annual-statements/annual-statement-enums";
import { ApproverStatus } from "@models/documents/approver-status.enum";
import { SignatureStatus } from "@models/documents/signature-status.enum";
import { SignRow } from "@models/documents/sign-documents";

@Component({
  selector: 'app-ag-signatory-status',
  standalone: true,
  imports: [
    SplitByCapitalLetterPipePipe,
    DatePipe
  ],
  templateUrl: './ag-signatory-status.component.html',
  styleUrl: './ag-signatory-status.component.scss'
})
export class AgSignatoryStatusComponent {
  protected status: ApproverStatus | SignatureStatus | null | undefined;
  protected signedOn = '';
  protected approvedOn = '';
  protected approverAdded = false;
  protected approverApproved = false;
  protected type: SignGroup | undefined;
  protected readonly SignatureStatus = SignatureStatus;
  protected readonly ApproverStatus = ApproverStatus;
  protected readonly SignGroup = SignGroup;

  agInit(params: ICellRendererParams<SignRow, ApproverStatus | SignatureStatus>): void {
    this.status = params.value;
    this.type = params.data?.type;
    this.signedOn = params.data?.signedOn ?? '';
    this.approvedOn = params.data?.approvedOn ?? '';
    this.approverApproved = params.data?.approverApproved ?? false;
    this.approverAdded = params.data?.approverAdded ?? false;
  }

  refresh(params: ICellRendererParams<SignRow, ApproverStatus | SignatureStatus>): boolean {
    this.status = params.value;
    this.type = params.data?.type;
    this.signedOn = params.data?.signedOn ?? '';
    this.approvedOn = params.data?.approvedOn ?? '';
    this.approverApproved = params.data?.approverApproved ?? false;
    this.approverAdded = params.data?.approverAdded ?? false;
    return true;
  }
}
